import { useAtom } from "jotai";
import { dnisNoProcesadosAtom, loadingAtom, rendimientoAtom } from "../store/store";
import { RendimientoService } from "services/comunicacion-cultura";
import { saveAs } from "file-saver";

const useRendimientoPage = () => {

    const [rendimiento, setRendimiento] = useAtom(rendimientoAtom);
    const [loading, setLoading] = useAtom(loadingAtom);
    const [dnisNoProcesados, setDnisNoProcesados] = useAtom(dnisNoProcesadosAtom);

    const fetchRendimiento = async (params) => {
        const data = await RendimientoService.listar(params);
        setRendimiento(data);
    };

    const exportar = async () => {
        try {
            setLoading(true);
            const response = await RendimientoService.exportar();
            const filename = response?.headers?.filename;
            saveAs(response.data, filename);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("No se pudo generar el excel");
        }
    };

    return {
        rendimiento,
        loading,
        dnisNoProcesados,
        setDnisNoProcesados,
        exportar,
        fetchRendimiento,
    };
};

export default useRendimientoPage;
